import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import { CometdActions } from "../../cometD/cometD-action";
import { useCometdContext } from '../../cometD/cometdProvider';
import DefaultFooter from '../CommonUtils/DefaultFooter';
import HWLog from "../HWLibrary/HWLog";
import HWUser from "../HWLibrary/HWUser";

import ConversationList from "./ConversationList";
import LandingPageHeader from "./LandingPageHeader";

import "../LandingPage/LandingPageStyleSheet.css";

function LandingPage(props) {
  const cometd = useCometdContext();
  const [agentsList, setAgentsList] = useState([]);
  const [sessionsList, setSessionsList] = useState([]);
  const [healthPings] = useState({});
  const [areAllPreviousSessionsClosed, setAreAllPreviousSessionsClosed] = useState(false);
  const [conversations, setConversations] = useState([])
  const [isFetchingConversations, setIsFetchingConversations] = useState(true);
  const [activeSession, setActiveSession] = useState(null);

  let chatStatus = {
    Active: "Active",
    New: "New",
    Previous: "Previous",
  };
  // var moveToNewConversation = false;
  let hideHistory = props.config.hideChatHis;
  let lastFetchedSessionListCount = 0;

  const fetchConversationsCometd = (lastFetchedSession) => {
    const { fetchConversationsCMD } = CometdActions(cometd);
    fetchConversationsCMD(30, lastFetchedSession);
  };

  const initialize = async () => {
    console.log("componentDidMount:landing");
    console.log("COMETD-LOG-CHECK:4 componentDidMount in landing page");

    // start cometd websocket session only after ensuring user is logged in
    if (HWUser.isLoggedIn()) {
      await props?.configureCometd();
      fetchConversationsCometd();
    }
  };

  const cometdActions = (message) => {
    if (!message) return;
    //  To add more cases, change it in XMPPService class.
    switch (message.command) {
      case "GET_AGENTS_RESPONSE":
        onAgentListResponse(message);
        break;
      case "UNIBOX_SINGLE_REFRESH":
        parseUniboxSingleRefresh(message);
        break;
      case "GET_SESSIONS_RESPONSE":
        onSessionsListResponseCometd(message);
        break;
      case "CREATE_SESSION":
        onCreateSessionResponseCometd(message);
        break;
      case "PING_RESPONSE":
        parseAgentStatusPingResponse(message);
        break;
      case "BOT_REPLY":
        onCreateSessionResponseCometd(message);
        break;
      default:
        break;
    }
  };

  const updateComponent = (event) => {
    if (event.detail && event.detail.componentsToUpdate && event.detail.componentsToUpdate.indexOf('LandingPage') >= 0) {
      const eventData = event?.detail?.data ?? {}
      console.log("COMETD-LOG:RECIEVED MESSAGE FROM COMETD", JSON.parse(eventData.message.data));
      cometdActions(JSON.parse(eventData.message.data));
    }
  };

  useEffect(() => {
    document.addEventListener("updateComponent", updateComponent);
    initialize();
    return () => {
      document.removeEventListener("updateComponent", updateComponent);
    }
  }, []);


  const landingPageActions = {
    createNewSessionCometd: () => {
      createNewSessionCometd();
    },
    checkAndStartNewConversationCometd: (session) => {
      checkAndStartNewConversationCometd(session);
    },
  };

  const createNewSessionCometd = () => {
    // moveToNewConversation = true;
    const { createSessionCMD } = CometdActions(cometd);
    createSessionCMD();
  };

  const checkAndStartNewConversationCometd = (session) => {
    console.log("COMETD-LOG: CLICKED ON NEW CONVERSATION TAB OR EXISTING LIST", session);
    localStorage.removeItem("selectedLanguage");
    if (session !== null && session !== undefined) {
      if (session.active) {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = chatStatus.Active;

        props.actions.startConversation(sessionToBePassed);

      } else {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = chatStatus.Previous;
        sessionStorage.removeItem("agentName");
        props.actions.startConversation(sessionToBePassed);
      }
    } else {
      createNewSessionCometd();
    }
  };

  const onSessionsListResponseCometd = (message) => {
    console.log("COMETD-LOG:PARSED SESSIONS LIST MESSAGES", message);

    if (!message.listSessionInfo || message.listSessionInfo.length === 0) {

      lastFetchedSessionListCount = 0;
      console.log("COMETD-LOG:EMPTY SESSIONS LIST");
      setIsFetchingConversations(false);

      if (props.config.hideChatHis) {
        checkAndStartNewConversationCometd();
      }
      return;
    } else {
      setSessionsList(message.listSessionInfo);
    }

    let conversationIds = conversations.map((i) => i.sessionId);
    let newConversations = message.listSessionInfo.filter((i) => conversationIds.indexOf(i.sessionId) === -1);
    lastFetchedSessionListCount = newConversations.length;

    let firstActiveConversation = [...newConversations].find((conversation) => conversation.active);
    if (firstActiveConversation) {

      setActiveSession(firstActiveConversation);
      if (firstActiveConversation.agentInfo?.firstName) {
        let agentNameTemp = firstActiveConversation.agentInfo.firstName + " " + firstActiveConversation.agentInfo.lastName
        sessionStorage.setItem("agentName", agentNameTemp.trim());
      }

    }
    console.log("COMETD-LOG:1ST ACTIVE CONVERSATION", firstActiveConversation);

    if (props.config.hideChatHis) {
      if (firstActiveConversation) {
        //TODO:AUTOMATICALLY MOVE TO CONVERSATION PAGE WITH NEW SESSION ID
        props.actions.startConversation(firstActiveConversation);
      } else {
        checkAndStartNewConversationCometd();
      }
    } else {
      setIsFetchingConversations(false);
      setConversations(props.config.configDetails.showPreviousSession
        ? [...conversations, ...newConversations]
        : firstActiveConversation
          ? [firstActiveConversation]
          : []);
      setAreAllPreviousSessionsClosed(newConversations.every((conversation) => !conversation.active));
    }
  };

  const onCreateSessionResponseCometd = (newSessionResponse) => {
    newSessionResponse.sessionStatus = chatStatus.New;
    console.log(" PAGE WITH NEW SESSION", newSessionResponse);
    sessionStorage.removeItem("agentConnected");
    sessionStorage.removeItem("agentName");
    props.actions.startConversation(newSessionResponse);

  };

  const parseUniboxSingleRefresh = function () {
    props.uniboxSingleRefreshChange();
    console.log("IN LANDING PAGE REFRESH")
  }

  // Parse Agents List Response.
  const onAgentListResponse = (message) => {
    HWLog.info("PARSED AGENTS LIST MESSAGES", message);
    if (!message?.listAgentInfo || message?.listAgentInfo.length === 0) {
      HWLog.info("EMPTY AGENTS LIST");
      return;
    }
    setAgentsList(message.listAgentInfo);
  };

  //   GREEN - Online
  //   RED - Offline
  //   Yellow - Away
  const parseAgentStatusPingResponse = (message) => {
    let sessionId = message.sessionId || "";
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }

    let conversations = (conversations || []).map((conversation) => {
      if (conversation.sessionId === sessionId) {
        conversation.active = status === "GREEN";
      }
      return conversation;
    });
    setConversations(conversations);
    HWLog.info("AGENT PING STATUS: " + status);
  };

  // MARK: Handle Session Pagination
  const onConversationScrollToBottom = () => {
    HWLog.info("SCROLLED TO BOTTOM:" + lastFetchedSessionListCount);
    if (lastFetchedSessionListCount === 0) {
      return;
    }
    fetchNextPageConversations();
  };

  const fetchNextPageConversations = () => {
    if (isFetchingConversations) {
      return;
    }
    let conversations = conversations || [];
    if (conversations.length === 0) {
      return;
    }
    setIsFetchingConversations(false);
  };

  return (
    <>
      {hideHistory && (
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <div style={{ textAlign: "center", paddingTop: "38vh" }}>
            <CircularProgress color="inherit" size={20} />
          </div>
        </div>
      )}
      {!hideHistory && (
        <div className="s360-conversation-list-view-container">
          <LandingPageHeader
            agentsList={agentsList}
            sessionsList={sessionsList}
            healthPings={healthPings}
            areAllPreviousSessionsClosed={areAllPreviousSessionsClosed}
            conversations={conversations}
            isFetchingConversations={isFetchingConversations}
            activeSession={activeSession}
            {...props}
          />
          <div className="s360-conversation">
            <ConversationList
              onScrollToBottom={onConversationScrollToBottom}
              landingPageActions={landingPageActions}
              agentsList={agentsList}
              sessionsList={sessionsList}
              healthPings={healthPings}
              areAllPreviousSessionsClosed={areAllPreviousSessionsClosed}
              conversations={conversations}
              isFetchingConversations={isFetchingConversations}
              activeSession={activeSession}
              {...props}
            />
          </div>
          <DefaultFooter {...props} />
        </div>
      )}
    </>
  );
}

export default LandingPage;
